import React, { Component } from 'react';

class ModelSelect extends Component {

    state = { 
        dataLoaded: false,
        year: this.props.year,
        make: this.props.make,
        models: []
    }

    componentDidMount(){
        // Fetch the years
        fetch(`${process.env.REACT_APP_API_URL}/vehicleInfo/getModels/${this.state.make}?year=${this.state.year}`, {
            method: 'GET'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result["success"] === true) {

                        this.setState({
                            ...this.state,
                            dataLoaded: true,
                            models: result.models
                        })
                    } else if (result["success"] === false) { 
                        console.log("Error fetching vehicle models.")
                    } else {
                        console.log("Error fetching vehicle models.")
                    }
                }).catch(error => {
                    console.log("Error fetching vehicle models.")                                      
                });  
    }

    render() { 
        return ( 
            this.state.dataLoaded ? 
                <select value={this.props.defaultValue} className="form-control" onChange={event => this.props.handleChange(this.props.questionId, event.target.value, false, true, 'model')}>
                    <option></option>
                    {this.state.models.map(model => {
                        return <option value={model}>{model}</option>
                    })}
                </select>
            :
                <select className="form-control">
                    <option> - </option>
                </select>
        );
    }
}
 
export default ModelSelect;